import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Chart } from 'angular-highcharts';
import Highcharts from 'highcharts';
import { Options } from 'highcharts';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ButtonEditDeleteBtnRenderer } from 'src/app/btn-edit-delete-renderer.component';
import { DataSourcesService } from 'src/app/services/data-sources.service';
import { DynamicDashboardService } from 'src/app/services/dynamic-dashboard.service';
import { DynamicdashboardService } from 'src/app/services/dynamicdashboard.service';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { BaseApi } from 'src/backend/api/base-api';
import { core_features } from 'src/@smartmanufacturing/common/custom_methods';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-landingpagetop',
  templateUrl: './landingpagetop.component.html',
  styleUrls: ['./landingpagetop.component.scss'],
})
export class LandingpagetopComponent implements OnInit {
  @ViewChild('AddTaskPoup') private addTaskPoup!: TemplateRef<any>;
  @ViewChild('AddFavPoup') private addFavPoup!: TemplateRef<any>;
  disabledDate = (current: Date): boolean => {
    // Disable dates before today
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to the start of the day
    return current < today;
  };

  userDetail: any;
  dashboardElementData: any[] = [];
  dashboardColumns: string[] = [
    'flag',
    'dueDate',
    'title',
    'status',
    'assignee',
  ];
  dashboardData = new MatTableDataSource<any>();
  flag: string = 'assets/images/flag.svg';
  cards = [];
  currentShiftOEE: Chart;
  YesterdayOEE: Chart;
  lastOEE: Chart;
  userMachines: any = [];
  columnDefsProcessOrder!: any[];
  columnDefsAM!: any[];
  columnDefsAction!: any[];
  gridApi!: any;
  gridColumnApi!: any;

  gridApitodo!: any;
  gridColumnApitodo!: any;
  public frameworkComponents: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true,
    },
  };
  languageDir = 'ltr';
  langObj: any = {};
  rowDataPO!: any[];
  rowDataAM!: any[];
  rowDataAction!: any[];
  PersonalInfoform: FormGroup;
  AddTaskform: FormGroup;
  AddFavform: FormGroup;
  oeeData: any;
  userImage: any;
  lastLoggedIn: any;
  department: string;
  plant: string;
  options: Options;
  filteredUser: any;
  groupSession: any;
  plantSession: any;
  todotaskId: any;
  IsEdit: boolean = false;
  menuId: any;
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);
  constructor(
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private baseApi: BaseApi,
    private DataSourceService: DataSourcesService,
    private dyservice: DynamicDashboardService,
    private router: Router,
    public translate: TranslateService,
    public translater: TranslaterService,
    private dynamicService: DynamicdashboardService,
    private machineMappingService: MachineMappingService,
    private userManagementService: UserManagementService,
    private toaster: ToastrService,
    private dialog: MatDialog
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.frameworkComponents = {
      editDeleteRenderer: ButtonEditDeleteBtnRenderer,
    };
    this.columnDefsProcessOrder = [
      {
        headerName: 'Process Order',
        field: 'PO',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Machine',
        field: 'PU_Desc',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'item',
        field: 'ItemCode',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'qty',
        field: 'Target',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'deliveryDate',
        field: 'EndDate',
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'status',
        field: 'PPS_Desc',
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];

    this.columnDefsAM = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'editDeleteRenderer',
        minWidth: 140,
        cellRendererParams: {
          onClickEdit: this.editRow.bind(this),
          onClickDelete: this.deleteRow.bind(this),
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Task',
        field: 'taskName',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Description',
        field: 'taskDescription',
        sortable: true,
        resizable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target Date',
        field: 'TargetDate',
        sortable: true,
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created Date',
        field: 'createdat',
        sortable: true,
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Created By',
        field: 'FullName',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'Status',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];

    this.columnDefsAction = [
      {
        headerName: 'Action',
        field: 'Action',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Module',
        field: 'Name',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target Date',
        field: 'TargetDate',
        sortable: true,
        valueFormatter: function (params: any) {
          return moment(params.value).format('MM/DD/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'Status',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Action Type',
        field: 'ActionType',
        sortable: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }

  ngOnInit(): void {
    this.getLangWords();
    this.initForm();
    this.getAction();
    this.getfavouriteList();
    this.getSessionData();
    this.getTODOList();
  }

  // Handle the delete feature command
  onEdit(cardData: any): void {
    this.openFavoritePopup();
    this.AddFavform.get('menuName')?.patchValue(cardData.menuName);
    this.AddFavform.get('order')?.patchValue(cardData.order);
    this.menuId = cardData.Id;
  }

  onDelete(cardData: any): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this feature from your favorite list!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
    }).then((result) => {
      if (result.isConfirmed) {
        const obj = {
          TransactionType: 2,
          Id: cardData.Id,
          menuId: cardData.menuId,
          url: cardData.route,
          menuName: cardData.label,
        };
        this.dyservice.saveFavorite(obj).subscribe((res: any) => {
          this.showPopupMsg(res.ErrorMessage);
          this.getfavouriteList();
        });
      }
    });
  }

  checkMaxDigitsWithDecimal(event: any): void {
    const inputValue = event.target.value;

    // Limit to 5 characters including the decimal point
    if (inputValue.length > 5) {
      event.target.value = inputValue.slice(0, 5); // Trim to 5 characters
    }
  }

  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
          ? 2
          : this.translate.currentLang === 'fr'
          ? 3
          : this.translate.currentLang === 'sp'
          ? 4
          : this.translate.currentLang === 'gr'
          ? 5
          : this.translate.currentLang === 'du'
          ? 6
          : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApitodo.refreshHeader();
      }
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  initForm() {
    this.PersonalInfoform = this.formBuilder.group({
      ProdUnit: ['', Validators.required],
    });
    const dateStart = new Date();
    dateStart.setDate(dateStart.getDate());
    this.AddTaskform = this.formBuilder.group({
      taskName: ['', Validators.required],
      taskDescription: ['', Validators.required],
      targetDate: [dateStart, Validators.required],
      status: ['open', Validators.required],
    });
    this.AddFavform = this.formBuilder.group({
      menuName: ['', Validators.required],
      order: ['', Validators.required],
    });
  }

  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.userDetail = this.baseApi.getUserSession();
    this.getUserMachineList();
  }

  showPopupMsg(msg: any): any {
    //
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        this.toaster.success('Success', msg.substring(3, msg.length));
      } else {
        this.toaster.error('Error', msg.substring(3, msg.length));
      }
    }
  }

  //==========================================================AgGrid======================================================================//
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onGridReadyTODO(params: any) {
    this.gridApitodo = params.api;
    this.gridColumnApitodo = params.columnApi;
  }
  rowClicked(params: any) {
    params.node.setData({
      ...params.data,
      dirty: true,
    });
  }

  getPersonalDashboard() {
    this.spinner.show();
    const key = {
      PUId: this.PersonalInfoform.get('ProdUnit').value,
    };
    this.dynamicService.getPersonalDashboardData(key).subscribe(
      (data: any) => {
        // this.rowDataPO = data.Table;
        this.rowDataAction = data.Table2;
        //this.oeeData = data.Table3;
        //this.lastLoggedIn = data.Table4[0]?.lastLogin;
        //this.department = data.Table4[0]?.department;
        //this.plant = data.Table4[0]?.plant;
        //this.guageDrawCurrent();
        //this.guageDrawLast();
        //this.guageDrawYesterday();
        this.spinner.hide();
      },
      (err: any) => {
        console.log(err);
        this.spinner.hide();
      }
    );
  }

  // ===================================================Personel Information code ============================================================//
  onChangeProdUnit(event: any) {
    // this.getPersonalDashboard();
  }
  setProfileData() {
    const key = {
      userId: this.userDetail.UserId,
      isAdmin: this.userDetail.IsAdmin,
    };
    this.userManagementService.getUserById(key).subscribe((res) => {
      this.userImage = res[0].ProfileImage
        ? res[0].FilePath
        : 'assets/images/img_avatar.png';
    });
  }
  guageDrawCurrent() {
    const data = parseFloat(this.oeeData[0]?.oeeCurrent?.toFixed(2));
    this.options = {
      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '45%',
      },

      title: {
        text: 'Current OEE',
        style: {
          fontWeight: 'bold', // Makes the title bold
        },
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%',
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '14px',
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 35,
            color: '#DF5353', // red
            thickness: 20,
          },
          {
            from: 35,
            to: 70,
            color: '#DDDF0D', // yellow
            thickness: 20,
          },
          {
            from: 70,
            to: 100,
            color: '#55BF3B', // green
            thickness: 20,
          },
        ],
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'OEE',
          type: 'gauge',
          data: [data],
          tooltip: {
            valueSuffix: ' %',
          },
          dataLabels: {
            format: '{y} %',
            borderWidth: 0,
            color:
              (Highcharts.defaultOptions.title &&
                Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              '#333333',
            style: {
              fontSize: '16px',
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 12,
            baseLength: '0%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 6,
          },
        },
      ],
    };
    let chart = new Chart(this.options);
    this.currentShiftOEE = chart;
  }

  guageDrawLast() {
    const data = parseFloat(this.oeeData[0]?.oeeLast?.toFixed(2));
    this.options = {
      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '45%',
      },

      title: {
        text: 'Last Shift OEE',
        style: {
          fontWeight: 'bold', // Makes the title bold
        },
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%',
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '14px',
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 35,
            color: '#DF5353', // red
            thickness: 20,
          },
          {
            from: 35,
            to: 70,
            color: '#DDDF0D', // yellow
            thickness: 20,
          },
          {
            from: 70,
            to: 100,
            color: '#55BF3B', // green
            thickness: 20,
          },
        ],
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'OEE',
          type: 'gauge',
          data: [data],
          tooltip: {
            valueSuffix: ' %',
          },
          dataLabels: {
            format: '{y} %',
            borderWidth: 0,
            color:
              (Highcharts.defaultOptions.title &&
                Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              '#333333',
            style: {
              fontSize: '16px',
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 12,
            baseLength: '0%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 6,
          },
        },
      ],
    };
    let chart = new Chart(this.options);
    this.lastOEE = chart;
  }

  guageDrawYesterday() {
    const data = parseFloat(this.oeeData[0]?.oeeYesterday?.toFixed(2));
    this.options = {
      chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '45%',
      },

      title: {
        text: 'Yesterday OEE',
        style: {
          fontWeight: 'bold', // Makes the title bold
        },
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%',
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '14px',
          },
        },
        lineWidth: 0,
        plotBands: [
          {
            from: 0,
            to: 35,
            color: '#DF5353', // red
            thickness: 20,
          },
          {
            from: 35,
            to: 70,
            color: '#DDDF0D', // yellow
            thickness: 20,
          },
          {
            from: 70,
            to: 100,
            color: '#55BF3B', // green
            thickness: 20,
          },
        ],
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'OEE',
          type: 'gauge',
          data: [data],
          tooltip: {
            valueSuffix: ' %',
          },
          dataLabels: {
            format: '{y} %',
            borderWidth: 0,
            color:
              (Highcharts.defaultOptions.title &&
                Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              '#333333',
            style: {
              fontSize: '16px',
            },
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 12,
            baseLength: '0%',
            rearLength: '0%',
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 6,
          },
        },
      ],
    };
    let chart = new Chart(this.options);
    this.YesterdayOEE = chart;
  }

  getUserMachineList() {
    const key = {
      UserCode: this.userDetail.userCode,
    };
    this.machineMappingService.getMachineMappingData(key).subscribe(
      (data: any) => {
        this.userMachines = data;
        this.PersonalInfoform.get('ProdUnit').setValue(
          this.userMachines[0].puId
        );
        this.filteredUser = this.userMachines.slice();
        this.getPersonalDashboard();
      },
      (err: any) => {
        console.log(err);
        // this.spinner.hide();
      }
    );
  }

  getfavouriteList() {
    this.cards = [];
    this.dyservice.getFavoriteList().subscribe((res: any) => {
      this.cards = res?.favoriteList;
    });
  }

  get sortedCards() {
    return this.cards.sort((a, b) => a.order - b.order);
  }
  getAction() {
    this.DataSourceService.getDashboardData().subscribe(
      (data: any) => {
        this.dashboardData = data;
        console.log('res is ', data);
      },
      (error) => {
        throw error;
      },
      () => console.log('finished')
    );
  }

  openTaskPopup() {
    let dialogRef = this.dialog.open(this.addTaskPoup, {
      minWidth: '65%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {
      if (this.IsEdit == false) {
        this.AddTaskform.get('targetDate').setValue(new Date());
        this.AddTaskform.get('status').setValue('open');
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.IsEdit = false;
      this.AddTaskform.reset();
    });
  }

  openFavoritePopup() {
    let dialogRef = this.dialog.open(this.addFavPoup, {
      minWidth: '65%',
      minHeight: '50%',
    });
    dialogRef.afterOpened().subscribe((res: any) => {});
    dialogRef.afterClosed().subscribe((res: any) => {});
  }

  // date validation =====//

  addTask(): void {
    if (this.AddTaskform.valid) {
      const key = {
        taskName: this.AddTaskform.get('taskName')?.value,
        taskDescription: this.AddTaskform.get('taskDescription')?.value,
        targetDate: this.AddTaskform.get('targetDate')?.value,
        status: this.AddTaskform.get('status')?.value,
        todoimage: '',
        TransactionType: 1,
        Id: 0,
      };
      this.spinner.show();
      this.dyservice.SaveTODOTask(key).subscribe(
        (data: any) => {
          if (data.ErrorMessage === null) {
            this.toaster.success('Success', 'Task Added Successfully!');
            this.spinner.hide();
            this.AddTaskform.reset();
            this.dialog.closeAll();
            this.getTODOList();
          }
        },
        (error) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinner.hide();
        }
      );
    }
  }

  getTODOList(): void {
    this.dyservice.getTODOlist().subscribe((res: any) => {
      this.rowDataAM = res?.Table;
    });
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.AddTaskform.controls[controlName].hasError(errorName);
  };

  editRow(data: any): void {
    this.openTaskPopup();
    this.IsEdit = true;
    this.todotaskId = data.rowData.id;
    this.AddTaskform.get('taskName')?.patchValue(data.rowData.taskName);
    this.AddTaskform.get('targetDate')?.patchValue(data.rowData.TargetDate);
    this.AddTaskform.get('taskDescription')?.patchValue(
      data.rowData.taskDescription
    );
    this.AddTaskform.get('status')?.patchValue(data.rowData.Status);
  }

  updateTask(): void {
    const key = {
      taskName: this.AddTaskform.get('taskName')?.value,
      taskDescription: this.AddTaskform.get('taskDescription')?.value,
      targetDate: this.AddTaskform.get('targetDate')?.value,
      status: this.AddTaskform.get('status')?.value,
      todoimage: '',
      TransactionType: 2,
      Id: this.todotaskId,
    };
    this.spinner.show();
    this.dyservice.SaveTODOTask(key).subscribe(
      (data: any) => {
        if (data.ErrorMessage === null) {
          this.toaster.success('Success', 'Task Updated Successfully!');
          this.spinner.hide();
          this.AddTaskform.reset();
          this.IsEdit = false;
          this.dialog.closeAll();
          this.getTODOList();
        }
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
        this.spinner.hide();
      }
    );
  }

  deleteRow(data: any): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this task!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
    }).then((result) => {
      if (result.isConfirmed) {
        const key = {
          taskName: data.rowData.taskName,
          taskDescription: data?.rowData.taskDescription,
          targetDate: data?.rowData.TargetDate,
          status: data?.rowData.Status,
          todoimage: '',
          TransactionType: 3,
          Id: data?.rowData?.id,
        };
        this.spinner.show();
        this.dyservice.SaveTODOTask(key).subscribe(
          (data: any) => {
            if (data.ErrorMessage === null) {
              this.toaster.success('Success', 'Task Deleted Successfully!');
              this.spinner.hide();
              this.getTODOList();
            }
          },
          (error) => {
            this.toaster.error('Error', error.ErrorMessage);
            this.spinner.hide();
          }
        );
      }
    });
  }
  updateMenu(): void {
    if (this.AddFavform.valid) {
      const obj = {
        TransactionType: 3,
        Id: this.menuId,
        menuId: '',
        url: '',
        menuName: this.AddFavform.get('menuName')?.value,
        order: this.AddFavform.get('order')?.value,
      };
      this.dyservice.saveFavorite(obj).subscribe((res: any) => {
        this.showPopupMsg(res.ErrorMessage);
        this.dialog.closeAll();
        this.AddFavform.reset();
        this.getfavouriteList();
      });
    }
  }

  navigateToHome(): void {
    this.baseApi.saveCurrentMenuID('');
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['Home']));
  }

  displayRightmenu(menuId: any, url: any, type: string, cardItem): any {
    // if (lean_features.includes(cardItem?.label)) {
    if (
      (cardItem?.applicationVariant === Constants.LEAN_APP_NAME ||
        cardItem?.applicationVariant === Constants.UI_FORM_BUILDER_APP_NAME ||
        cardItem?.applicationVariant === Constants.UTILITY_APP_NAME) &&
      cardItem.type === Constants.MENU_TYPE_LINK
    ) {
      const appURL = this.baseApi.getAppURL(cardItem?.applicationVariant);
      const plantCode: string = this.baseApi.getPlantCodeFromStorage();
      const groupCode: string = this.baseApi.getGroupCodeFromStorage();
      const queryParams = {
        email: this.userDetail?.userName,
        plantCode,
        groupCode,
        menuId: cardItem?.menuId,
        languageName: localStorage.getItem('Language_Name'),
        token: this.baseApi.getTokenFromStorage(),
      };
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(queryParams),
        this.key,
        { iv: this.iv }
      );

      this.openUrlWithParameters(appURL, {
        encrypted: encrypted.toString(),
      });
    } else if (core_features.includes(cardItem?.label)) {
      if (cardItem?.menuId === 'M-411') {
        this.baseApi.saveCurrentMenuID(cardItem?.menuId);
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['landing']));
      } else {
        this.baseApi.saveCurrentMenuID(cardItem?.menuId);
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['Home']));
      }
    } else {
      this.baseApi.saveCurrentMenuID(menuId);
      switch (type) {
        case 'subheading':
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
        case 'dropdown':
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
        case 'link':
          if (url.indexOf('/Home/ExternalLink?link=') > -1) {
            url = url.replace('/Home/ExternalLink?link=', '');
            window.open(url, '_blank');
          }
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate([url]));
          break;
        default:
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['Home']));
          break;
      }
    }
  }
  openUrlWithParameters(
    url: string,
    parameters: { [key: string]: string }
  ): void {
    const queryString = Object.keys(parameters)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`
      )
      .join('&');
    const urlWithParameters = `${url}?${queryString}`;
    window.open(urlWithParameters, '_self');
  }
}
